import { useId } from 'react'

export const useHtmlId = (prefix = '') => {
  return `${prefix}${useId().replace(/[^a-zA-Z0-9]/g, '-')}`
}
